import { inject, Injectable } from '@angular/core';
import { concatMap, defer, delay, from, map, Observable, of, retry, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../../shared/contract/user.contract';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UserExternalSyncService {
  private authService = inject(AuthService);

  sync(token: string): Observable<User> {
    return this.sendSyncRequest(token).pipe(
      switchMap(() => this.checkUserCreated(5, 3000)),
      map(() => this.authService.user),
    );
  }

  private sendSyncRequest(token: string): Observable<unknown> {
    const resultPromise = new Promise((resolve, reject) => {

      const options = {
        method: 'POST',
        url: environment.APP_USERROLE_SERVICE_BASE_URL + '/api/v1/users/external-sync',
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + token
        },
      };

      const xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', options.url);
      if (options.headers) {
        Object.keys(options.headers).forEach((key) => {
          xhr.setRequestHeader(key, (options.headers as Record<string, string>)[key]);
        });
      }
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(xhr.response);
          } else {
            reject(xhr.responseText);
          }
        }
      };
      xhr.onerror = () => reject(xhr.responseText);
      xhr.send();
    });

    return from(resultPromise);
  }


  private checkUserCreated(retryCount: number, retryDelay: number): Observable<unknown> {
    return defer(() => this.authService.updateToken(999999 * 60))
      .pipe(
        delay(environment.DELAY_SHORTEST),
        map(() => this.authService.user?.userId),
        concatMap((userId) => userId ? of(userId) : throwError(() => 'Token timeout')),
        retry({ count: retryCount, delay: retryDelay }),
      );
  }

}
